
angular.module('app')
    .controller('calendario', function ($scope, $http, $filter) {

        //// page is now ready, initialize the calendar...
        $('#calendar').fullCalendar({
            header: {
                center: 'title',
                right:'month,prev,next'
            },
            height: 'auto',
            eventLimit: 3,           
            displayEventTime: false,
            events: function(start, end, timezone, callback) {
                $.ajax({
                    url: '/api/events/currentevents',
                    dataType: 'json',
                    success: function (response) {
                        var eventsArray = [];
                        for (var i = 0; i < response.length; i++) {
                            eventsArray.push({
                                id: response[i].MeetingId,
                                url: response[i].PageUrl,
                                title: response[i].MeetingName,
                                start: response[i].EventStartDate,
                                end: response[i].EventEndDate,
                                backgroundColor: response[i].CMECreditAvailable ? '#f0a948' : '#666',
                                description: getDescription(response[i]),
                                allDay: (start === end)
                            });
                        }
                        callback(eventsArray);
                    }
                });
            },
            eventRender: function (event, element) {
                element.prop('title', event.description);
                //var tooltip = new Tooltip(element, {
                //    title: event.description,
                //    placement: 'top',
                //    trigger: 'hover',
                //    container: 'body'
                //});
            }
        });

        var eventStartDate = $('.calendarStartDate').data('event-start-date');
        $('#calendar').fullCalendar('gotoDate', new Date(eventStartDate));

        function getDescription(event) {
            var description = event.MeetingName;
            if (event.CMECreditAvailable) {
                description += ' | ' + 'CME Hours: ' + event.CMEHours;
            }

            if (event.Address !== '') {
                if (event.CMECreditAvailable) {
                    description += ' | ';
                }
                description += event.Address;
            }

            return description;
        }
        
    });


//////////////////
// WEBPACK FOOTER
// ./static/common/js/controllers/_calendarIo.js
// module id = 8
// module chunks = 0